import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { ReactComponent as MinusIcon } from '../../../icons/minus.svg';
import { ReactComponent as PlusIcon } from '../../../icons/plus.svg';

import './TempoControl.scss';

const MIN_BPM = 20;
const MAX_BPM = 300;
const BPM_STEP = 5;

const clampBpm = (value) => Math.min(MAX_BPM, Math.max(MIN_BPM, value));

/*
 * Playback tempo, adjustable for practicing a clip slower or faster than it was recorded.
 *   [ - ]  120  [ + ]
 */
const TempoControl = ({ bpm, onChange }) => {
  const { t } = useTranslation();
  const [inputValue, setInputValue] = useState(String(bpm));

  useEffect(() => {
    setInputValue(String(bpm));
  }, [bpm]);

  const step = (delta) => onChange(clampBpm(bpm + delta));

  const commitInput = () => {
    const parsed = parseInt(inputValue, 10);

    if (Number.isNaN(parsed)) {
      setInputValue(String(bpm));
      return;
    }

    const clamped = clampBpm(parsed);

    setInputValue(String(clamped));
    onChange(clamped);
  };

  return (
    <div className="TempoControl" aria-label={t('dialogs.midi.tempo')}>
      <button
        type="button"
        className="btn-step"
        onClick={() => step(-BPM_STEP)}
        aria-label={t('dialogs.midi.decreaseTempo')}
      >
        <MinusIcon />
      </button>
      <input
        type="number"
        className="value"
        value={inputValue}
        onChange={(e) => setInputValue(e.target.value)}
        onBlur={commitInput}
        onKeyDown={(e) => e.key === 'Enter' && e.currentTarget.blur()}
        min={MIN_BPM}
        max={MAX_BPM}
      />
      <button
        type="button"
        className="btn-step"
        onClick={() => step(BPM_STEP)}
        aria-label={t('dialogs.midi.increaseTempo')}
      >
        <PlusIcon />
      </button>
    </div>
  );
};

export default TempoControl;
